module.exports = "https://www.gc-pro.gnp.com.mx/d771f6d64e8ad67c19c88437f51c32f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_information.png
// module id = 328
// module chunks = 0